// extracted by mini-css-extract-plugin
export default {"formBody":"ProsperLoanTab_formBody__-v1TG","text":"ProsperLoanTab_text__9f0N4","button":"ProsperLoanTab_button__Ktxte"};